module.exports = __webpack_public_path__ + "img/crystal2.f684144b.jpeg";